import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../authentication/auth.service';
import { ApiServiceBase } from '../../base/api-service-base';
import { ServiceReferenceModel } from '../../models/reference-model/reference-general-model/service-reference.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceReferenceService extends ApiServiceBase {
  private readonly PATH = "/system/ServiceReference";

  constructor(httpClient: HttpClient,
    authService: AuthService) {
      super(httpClient, authService);
    }

  public getServiceReference(): Observable<ServiceReferenceModel[]> {
    return this.httpGet<ServiceReferenceModel[]>(this.PATH, null)
      .pipe(
        map(response => response.body)
      )
  }
}
